import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { BASICUNIT, BASICUNIT_ADD, BASICUNIT_DELETE } from "./actionTypes";
import {
  apiError,
  getBasicUnits,
  BasicUnitListSuccessful,
  BasicUnitAddSuccessful,
} from "./actions";

// AUTH related methods
import {
  postAdd,
  getList,
  postEdit,
  postDelete,
  // getRowData,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* getBasicUnit() {
  try {
    const response = yield call(getList, "/masters/baseunits/", {});
    yield put(BasicUnitListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
//If user is login then dispatch redux action's are directly from here.
function* AddBasicUnit({ payload: { BasicUnit } }) {
  try {
    if (BasicUnit.id === "") {
      const response = yield call(postAdd, "/masters/baseunits/", {
        name: BasicUnit.name,
      });
      if (response.status === 201) {
        swal("Your BasicUnit Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getBasicUnits());
      } else {
        swal("Sorry! Unable to ad BasicUnit. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(BasicUnitAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/baseunits/" + BasicUnit.id,
        {
          code: BasicUnit.code,
          name: BasicUnit.name,
          modifiedon: new Date(BasicUnit.createdon),
        }
      );
      if (response.status === 200) {
        swal("Your BasicUnit Edited Successfully.!", {
          icon: "success",
          timer: 1500,
        });
        yield put(getBasicUnits());
      } else {
        swal("Sorry! Unable to edit Location. Please Try Again!", {
          icon: "error",
        });
      }
      yield put(BasicUnitAddSuccessful(null));
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });
    //yield put(apiError(error));
  }
}

//If user is login then dispatch redux action's are directly from here.
function* DeleteBasicUnit(BUId) {
  try {
    const response = yield call(
      postDelete,
      "/masters/baseunits/" + BUId.payload.BUId
    );
    if (response.status === 204) {
      swal("Your BasicUnit has been deleted!", {
        icon: "success",
        timer: 1500,
      });
      yield put(getBasicUnits());
    } else {
      swal("Sorry! Your BasicUnit has been not deleted!", {
        icon: "error",
      });
    }
    // yield put(locationDeleteSuccessful(response.statusText))
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

export function* watchgetLocations() {
  yield takeEvery(BASICUNIT, getBasicUnit);
}
export function* watchLocationAdd() {
  yield takeEvery(BASICUNIT_ADD, AddBasicUnit);
}

export function* watchLocationDelete() {
  yield takeEvery(BASICUNIT_DELETE, DeleteBasicUnit);
}

function* BasicUnitSaga() {
  yield all([
    fork(watchgetLocations),
    fork(watchLocationAdd),
    fork(watchLocationDelete),
  ]);
}

export default BasicUnitSaga;
